/**
 * Configure checkout-rules-config:
 *
 */
angular.module('checkout').service(
    'checkoutRulesConfig',
    [
        'checkoutRules',
        function (checkoutRules) {

            let self = this;

            self.configure = function () {

                angular.forEach(
                    self.config,
                    function (value, key) {
                        checkoutRules.add(
                            key,
                            value
                        );
                    }
                );
            };
        },
    ]
);
